module.exports = __webpack_public_path__ + "static/media/family.a76414ad.png";